export function formSticky() {
    let $win = $(window);
    let positionAbsoluteClass = "position-absolute";
    let positionStickyClass = "position-sticky";
    let stickyElement = $(".landing-form-wrapper");
    let landingContent = $(".landing-container");
    let header = $('.header');
    let setMinHeight = () => {

        if ($win.outerWidth() >= 1440) {
            if (stickyElement.outerHeight() !== stickyElement.css('min-height') && landingContent.outerHeight() < stickyElement.outerHeight()) {
                landingContent.css('min-height', stickyElement.outerHeight());
            }
        } else {
            landingContent.css('min-height', '');
        }
    };

    function checkIsLargeBreakpoint() {
        let sticky = document.querySelector(".sticky-spacer");

        if (($win.outerWidth() >= 1440 && (stickyElement.outerHeight() > $win.outerHeight() - header.outerHeight()))) {
            sticky.setAttribute("style", "position:absolute");
        } else {
            sticky.setAttribute("style", "");
        }

        return $win.outerWidth() >= 1440 && (stickyElement.outerHeight() < $win.outerHeight() - header.outerHeight());
    }

    $win.on("load resize orientationchange scroll", function () {
        let curSection = document.querySelector(".landing-container");

        let togglePositionClass = function () {
            if (checkIsLargeBreakpoint()) {
                let targetBlock = $(curSection).find(".sticky-spacer")[0];
                let offsetTop = $(curSection).offset().top;
                let winScrollTop = $win.scrollTop();
                let bottomPosition = offsetTop + $(curSection).height() - $(targetBlock).height() - 160;
                let isScrollOutsideTheBottomPosition = bottomPosition < winScrollTop;
                let isRemoveStickyClass = isScrollOutsideTheBottomPosition || ((offsetTop - header.height()) >= winScrollTop); //>offsetTop - header.height()

                if (isRemoveStickyClass) {
                    targetBlock.classList.remove(positionStickyClass);
                    targetBlock.classList[`${isScrollOutsideTheBottomPosition ? "add" : "remove"}`](positionAbsoluteClass);

                    if ((offsetTop - header.height()) === winScrollTop) {
                        targetBlock.classList.add(positionAbsoluteClass);
                        targetBlock.setAttribute("style", "top:173px; bottom:auto");
                    }

                } else {
                    // targetBlock.setAttribute("style", "top:173px;");
                    targetBlock.classList.remove(positionAbsoluteClass);
                    targetBlock.classList.add(positionStickyClass);
                    targetBlock.setAttribute("style", "");
                }
            }
        };

        togglePositionClass();
        setMinHeight();
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/formSticky.js